import React from 'react';
import { Column } from 'rbx';
import styled from 'styled-components';

const Container = styled(Column.Group)`
  border-bottom: 1px solid #b0b0b0;
  background-color: #fbf8f8;
`;

const ItemWithoutVariant = ({ itemLink }) => {
  const discountTypeOptions = [
    { value: 'PERCENTAGE', label: '% rate' },
    { value: 'PRICE', label: 'flat rate' },
  ];

  const discountType = itemLink.type
    ? discountTypeOptions.find(ele => ele.value === itemLink.type)
    : discountTypeOptions[0];

  const discountValue = itemLink.value || 0;

  return (
    <>
      <Container>
        <Column size={2}>{itemLink.name}</Column>
        <Column size={10} style={{ fontSize: '13px' }}>
          <Column.Group>
            <Column size={2}>
              ${parseFloat(itemLink.menu_item_price || 0).toFixed(2)}
            </Column>
            <Column size={2} style={{ paddingTop: '8px' }}>
              {discountType.label}
            </Column>
            <Column size={2}>
              {discountType?.value === 'PRICE'
                ? `$${discountValue}`
                : `${discountValue}%`}
            </Column>
            <Column size={2}>
              ${parseFloat(itemLink.new_price).toFixed(2)}
            </Column>
            <Column size={2}>${parseFloat(itemLink.savings).toFixed(2)}</Column>
          </Column.Group>
        </Column>
      </Container>
    </>
  );
};

export default ItemWithoutVariant;
